export const MuiTab = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      minHeight: '4rem',
      p: '12px 16px',
      backgroundColor: 'transparent',
      fontSize: '1.6rem',
      fontFamily: 'Avenir Next World',
      color: '#000000c4',
      fontWeight: '200',
      textTransform: 'none',

      '&.Mui-selected': {
        color: '#0000FF',
        backgroundColor: '#fff',
      },
    },
  },
};
